import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import ServicesCardSection from "../ItPage/ServicesCardSection/ServicesCardSection";
import BgvStepsSection from "../ItPage/BgvStepsSection/BgvStepsSection";
import BgvServiceSection from "../ItPage/BgvServiceSection/BgvServiceSection";
import BrandCarousel from "../ItPage/BrandCarousel/BrandCarousel";
import ButtonComponent from "../../Components/Buttons/ButtonComponent";
import { Helmet } from "react-helmet-async";

const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";

const bg_image = `${digitalOceanURL}/About_Us_img/About_bg.png`;
const Education_IMG = `${digitalOceanURL}/Sector/Education_Img.png`;

export default function Education() {
  return (
    <>
      <Helmet>
        <title>Education Background Verification & Academic Checks</title>
        <meta
          name="description"
          content="Hirestar.io ensures trust & compliance in education. Get background checks for faculty, staff, & student identity verification. Onboard securely!"
        />
        <meta
          name="keywords"
          content="education background checks, teacher verification, student identity verification, academic verification, staff onboarding, degree verification"
        />
        <meta property="og:site_name" content="Hirestar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta
          property="og:title"
          content="Education Background Verification & Academic Checks"
        />
        <meta
          property="og:description"
          content="Hirestar.io ensures trust & compliance in education. Get background checks for faculty, staff, & student identity verification. Onboard securely!"
        />
        <meta
          property="og:url"
          content="https://hirestar.io/industries/education"
        />
        <meta property="og:locale" content="en_US" />

        <meta property="og:type" content="website" />
        <meta property="og:image" content={Education_IMG} />
        <meta property="og:image:type" content="image/png" />

        <meta name="robots" content="index, follow" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Education Background Verification & Academic Checks"
        />
        <meta
          name="twitter:description"
          content="Hirestar.io ensures trust & compliance in education. Get background checks for faculty, staff, & student identity verification. Onboard securely!"
        />
        <meta name="twitter:image" content={Education_IMG} />
      </Helmet>

      <div className=" relative  background_color ">
        {/* Image that is hidden on small screens */}
        <img
          src={bg_image}
          alt="education-img hero img"
          className="absolute  object-cover w-full lg:h-[150%] h-[110%] md:h-[120%] bg_curve_img"
        />

        <div className="mb-16 relative  w-full h-full md:top-28 lg:top-0">
          <div className="grid grid-cols-12 gap-4 justify-items-center relative top-0 lg:top-32 lg:mx-20 xl:mx-32 2xl:mx-40 items-center">
            {/* Text container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-7 w-full Banking_heading font-semibold font-[poppins] top_spacing h-[30rem]">
              <span className="industry_info">Education</span>
              <div className="mx-2 lg:mx-0">
                <h1 className="w-full text-[32px] md:text-[40px] lg:text-[46px]">
                  Strengthening Confidence in Educational Background Checks
                </h1>
                <h2 className="about-text-para mt-2">
                  Ensure a secure learning environment by verifying identities
                  and streamlining onboarding for educators, staff, and
                  students.
                </h2>
              </div>

              {/* Button Group */}
              <div className="mt-4">
                <ButtonComponent
                  arialLabel={
                    "Get in touch with an expert for Strengthening Confidence in Educational Background Checks"
                  }
                />
              </div>
            </div>

            {/* Image container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-5 relative   lg:top-2 bottom_space mb-20 lg:mb-0">
              <img
                src={Education_IMG}
                alt="about-girl education img"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="lg:mt-[24rem] md:mt-[12rem] mt-[8rem]">
        <BrandCarousel />
      </div>
      {/* 3 section */}
      <BgvServiceSection Sector="Education Sector" />

      <ServicesCardSection Sector="Education Sector" Sector_cards="education" />
      <div className="mb-48">{<BgvStepsSection />}</div>
      <FaqComponent />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
}
